import { createActions, createState, createReducer } from 'reduxsauce-crud'
import { clone, findIndex, propEq } from 'ramda'

const getCardIndexFromUnauth = (card_id, state) => {
  const newCards = clone(state.get.results)
  const oldCardIndex = findIndex(propEq('id', card_id))(newCards.unauthorized)
  return { newCards, oldCardIndex }
}
const getCardIndexFromAuth = (card_id, state) => {
  const newCards = clone(state.get.results)
  const oldCardIndex = findIndex(propEq('id', card_id))(newCards.authorized)
  return { newCards, oldCardIndex }
}

const d = { deep: true }
export const CardsRedux = createActions(
  {
    resetError: [],
    createCardRequest: ['student_id', 'parent_id', 'card_info', 'fromParent'],
    createCardSuccess: ['results'],
    createCardError: ['error'],
    unauthorizeRequest: ['student_id', 'card_id', 'fromParent'],
    unauthorizeSuccess: ['card_id', 'card'],
    unauthorizeError: ['error'],
    authorizeRequest: ['student_id', 'card_id', 'fromParent'],
    authorizeSuccess: ['card_id', 'card'],
    authorizeError: ['error'],
    activateRequest: ['student_id', 'card_id', 'fromParent'],
    activateSuccess: ['card_id'],
    activateError: ['error'],
    deleteRequest: ['card_id', 'fromParent'],
    deleteSuccess: ['card_id'],
    deleteError: ['error'],
  },
  {
    prefix: 'CARDS_',
    defaultActions: {
      update: true,
      delete: true,
      get: true,
      getOne: true,
    },
  },
)

const { Types, Creators } = CardsRedux
export const CardsTypes = Types
export default Creators

export const INITIAL_STATE = createState(
  {
    auth: {
      fetching: false,
      error: null,
    },
    activate: {
      fetching: false,
      error: null,
    },
    create: {
      fetching: false,
      error: null,
    },
  },
  {
    update: true,
    delete: true,
    get: true,
    getOne: true,
  },
)

const resetError = state =>
  state.merge(
    {
      create: { fetching: false, error: null },
      activate: { fetching: false, error: null },
    },
    d,
  )

const createCardRequest = state => state.merge({ create: { fetching: true, error: null } }, d)
const createCardSuccess = (state, { results }) =>
  state.merge({ create: { fetching: false, error: null }, get: { results } }, d)
const createCardError = (state, { error }) => state.merge({ create: { fetching: false, error } }, d)

const unauthorizeRequest = state => state.merge({ auth: { fetching: true, error: null } }, d)
const unauthorizeSuccess = (state, { card_id, card }) => {
  const { newCards, oldCardIndex } = getCardIndexFromAuth(card_id, state)
  newCards.authorized.splice(oldCardIndex, 1)
  newCards.unauthorized.push(card)
  return state.merge({ auth: { fetching: false, error: null }, get: { results: newCards } }, d)
}
const unauthorizeError = (state, { error }) => state.merge({ auth: { fetching: false, error } }, d)

const authorizeRequest = state => state.merge({ auth: { fetching: true, error: null } }, d)
const authorizeSuccess = (state, { card_id, card }) => {
  const { newCards, oldCardIndex } = getCardIndexFromUnauth(card_id, state)
  newCards.unauthorized.splice(oldCardIndex, 1)
  newCards.authorized.push(card)
  return state.merge({ auth: { fetching: false, error: null }, get: { results: newCards } }, d)
}
const authorizeError = (state, { error }) => state.merge({ auth: { fetching: false, error } }, d)

const activateRequest = state => state.merge({ activate: { fetching: true, error: null } }, d)
const activateSuccess = (state, { card_id }) => {
  const { newCards, oldCardIndex: newActiveCardIndex } = getCardIndexFromAuth(card_id, state)
  const currentActiveCardIndex = findIndex(propEq('is_default', true))(newCards.authorized)
  const newActiveCard = newCards.authorized[newActiveCardIndex]
  newCards.authorized[currentActiveCardIndex].is_default = false
  newActiveCard.is_default = true
  newCards.authorized.splice(newActiveCardIndex, 1)
  newCards.authorized.unshift(newActiveCard)
  return state.merge({ activate: { fetching: false, error: null }, get: { results: newCards } }, d)
}
const activateError = (state, { error }) => state.merge({ activate: { fetching: false, error } }, d)

const deleteRequest = state => state.merge({ activate: { fetching: true, error: null } }, d)
const deleteSuccess = (state, { card_id }) => {
  const { newCards, oldCardIndex } = getCardIndexFromUnauth(card_id, state)
  newCards.unauthorized.splice(oldCardIndex, 1)
  return state.merge({ activate: { fetching: false, error: null }, get: { results: newCards } }, d)
}
const deleteError = (state, { error }) => state.merge({ activate: { fetching: false, error } }, d)

export const reducer = createReducer(
  INITIAL_STATE,
  {
    [Types.resetError]: resetError,
    [Types.createCardRequest]: createCardRequest,
    [Types.createCardSuccess]: createCardSuccess,
    [Types.createCardError]: createCardError,
    [Types.unauthorizeRequest]: unauthorizeRequest,
    [Types.unauthorizeSuccess]: unauthorizeSuccess,
    [Types.unauthorizeError]: unauthorizeError,
    [Types.authorizeRequest]: authorizeRequest,
    [Types.authorizeSuccess]: authorizeSuccess,
    [Types.authorizeError]: authorizeError,
    [Types.activateRequest]: activateRequest,
    [Types.activateSuccess]: activateSuccess,
    [Types.activateError]: activateError,
    [Types.deleteRequest]: deleteRequest,
    [Types.deleteSuccess]: deleteSuccess,
    [Types.deleteError]: deleteError,
  },
  {
    defaultActions: {
      update: true,
      delete: true,
      get: true,
      getOne: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CardsRedux.js